var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 21h12.52M7.326 8.67 2 7.536 5.48 17l14.497-2.683L20 3.96l-4.757 3.096L10.556 3l-3.23 5.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUud1);
export default __webpack_public_path__ + "static/media/uud1.fdcff27e2ecbc09ffa8cf1cf044dc076.svg";
export { ForwardRef as ReactComponent };